<template>
  <form novalidate @submit.prevent="debounceSearch">
    <div class="columns my-0">
      <div class="column is-4">
        <kst-input floating-label load-on-focus
          field="Search" :data="searchData" :catalog="SearchCatalog"
          @input="handleInput"
        />
      </div>
      <div class="column is-narrow">
        <kst-input floating-label
          field="WarehouseID" :data="searchData" :catalog="SearchCatalog"
          :options="warehouseOptions" @input="handleInput"
        />
      </div>
      <div class="column is-narrow">
        <kst-input floating-label
          field="StatusID" :data="searchData" :catalog="SearchCatalog"
          :options="statusOptions" @input="handleInput"
        />
      </div>
      <div class="column is-narrow">
        <kst-input floating-label
          field="Date" :data="searchData" :catalog="SearchCatalog"
          @input="handleInput"
        />
      </div>

      <div class="column is-narrow">
        <kst-button reset-mode @click="handleReset"/>
        <input type="submit" value="Cari" class="is-hidden">
      </div>
    </div>
  </form>
</template>

<script>
import SearchCatalog from "./SalesSearchCatalog.js";
import SearchMixin from "@/mixins/SearchMixin.js";

export default {
  mixins: [SearchMixin],
  props: {
    searchData: Object,
    warehouseOptions: Object,
    statusOptions: Object
  },
  data: () => ({
    SearchCatalog: SearchCatalog
  }),
  created() {
    this.initSearch(this.searchData, this.submit);
  },
  methods: {
    handleInput() {
      this.handleSearch();
    },
    submit() {
      this.$emit(this.$kst.Enum.Event.Submit);
    },
    handleReset() {
      this.$emit(this.$kst.Enum.Event.Reset);
    }
  }
}
</script>